import React, { useState } from "react";
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import eidWish from "../../images/eidWish.jpg";

export const TextPopupModal = ({ show, handleClose, text }) => {
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        handleClose();
      }, 3000);
    }
  }, [show]);

  return (
    <Modal size="lg" show={show} centered>
      <Modal.Body>
        <div className="otpModalMain broadcastModal">
          <div className="showMoreModalM">
            <div className="showMoreModal">
              {/* <div className="eidModalImg">
                <img src={eidWish} alt="eid mubarak" />
              </div> */}
              <h4 className="my-3 text-center">{text}</h4>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
